import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import { StocksService } from '@toro/common/shared/services/stocks/stocks.service';
import { HighchartsService } from './../../services/highcharts.service';

import { NgModule } from '@angular/core';
import { BackendService } from '@toro/common/shared/services/new-http/backend.service';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';
import { StockTrackingChartsWraperComponent } from './stock-tracking-charts-wraper/stock-tracking-charts-wraper.component';
import { TrTrackingChartModule } from './tr-tracking-chart/tr-tracking-chart.module';
import { TraderadvisorNegativeColumnComponent } from './traderadvisor-column-negative/traderadvisor-column-negative.component';
import { TraderadvisorDonutComponent } from './traderadvisor-donut/traderadvisor-donut.component';
import { TraderadvisorGaugeComponent } from './traderadvisor-gauge/traderadvisor-gauge.component';
import { TraderadvisorScatterComponent } from './traderadvisor-scatter/traderadvisor-scatter.component';

const components = [
    StockTrackingChartsWraperComponent,
    TraderadvisorGaugeComponent,
    TraderadvisorScatterComponent,
    TraderadvisorDonutComponent,
    TraderadvisorNegativeColumnComponent,
];

@NgModule({
    imports: [
        CommonModule,
        TrTrackingChartModule,
    ],
    declarations: components,
    exports: components,
    providers: [
        HighchartsService,
        StocksService,
        UtilitiesService,
        CurrencyPipe,
        DecimalPipe,
        BackendService,
    ],
})
export class ChartsModule { }
